export default __webpack_public_path__ + "static/media/filter.c4a7b579.svg";